import { useCallback, useState } from "react";
import { isQueued } from "../lib/api";
import { errorMessage } from "../lib/useAsync";
import { Icon } from "./Icon";

export type NoticeState = { tone: "error" | "ok"; text: string } | null;

/** Inline result banner for actions (replaces window.alert). */
export function useNotice() {
  const [notice, setNotice] = useState<NoticeState>(null);
  // An action saved to send later is not an error: say so as done.
  const fail = useCallback((e: unknown) => setNotice({ tone: isQueued(e) ? "ok" : "error", text: errorMessage(e) }), []);
  const ok = useCallback((text: string) => setNotice({ tone: "ok", text }), []);
  return { notice, setNotice, fail, ok };
}

export function Notice({ notice, onDismiss }: { notice: NoticeState; onDismiss: () => void }) {
  if (!notice) return null;
  return (
    <div className={`notice notice--${notice.tone}`} role={notice.tone === "error" ? "alert" : "status"}>
      <Icon name={notice.tone === "error" ? "warning" : "check"} size={20} />
      <p>{notice.text}</p>
      <button type="button" className="icon-btn" aria-label="Dismiss message" onClick={onDismiss}>
        <Icon name="close" size={18} />
      </button>
    </div>
  );
}
